import React from "react";
import { MDBRow, MDBCol, MDBView, MDBAnimation } from "mdbreact";

class Start extends React.Component {
  render() {
    return (
      <div id="passenger">
        <MDBView className="view-homepage">
          <MDBRow
            style={{
              paddingTop: "40px",
              justifyContent: "left"
            }}
            >
            <MDBCol lg="6" md="6" sm="6">
              <MDBAnimation type="fadeInLeft" delay=".3s" align="left">
                <div style={{
                    display: "flex",
                    justifyContent: "left"
                    
                  }}>
                  <div className="col-lg-12 col-md-9 col-sm-6">
                    <p className="mt-2 f_heading" style={{textAlign:"left"}}>
                      Viaja <span style={{color: "#fed700"}}>seguros</span> y de <span style={{color: "#fed700"}}>calidad</span> a un solo toque
                    </p>
                  </div>
                </div>
                
                <div style={{
                  display: "flex",
                  justifyContent: "left",
                  marginTop: "20px"
                  }}>
                  <div className="col-lg-12 col-md-9 col-sm-6">
                    <p className="dp_heading">
                      Con Tovo disfruta de viajes compartidos, seguros y cómodos al alcance de tu bolsillo y a un click de distancia.
                    </p>
                  </div>
                </div>

                <div style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "0px"
                  }}>
                  
                </div>
              </MDBAnimation>
            </MDBCol> 
          </MDBRow>
        </MDBView>
      </div>
    );
  }
}

export default Start;
